import { useNavigate, NavigateOptions } from 'react-router-dom';
import { useLocalePath } from '@/hooks/useLocalePath';
import { useCallback } from 'react';

/**
 * A locale-aware useNavigate that automatically prepends the current locale prefix.
 * Supports both string paths and numeric history navigation (e.g., -1).
 */
export const useLocaleNavigate = () => {
  const navigate = useNavigate();
  const localePath = useLocalePath();

  return useCallback(
    (to: string | number, options?: NavigateOptions) => {
      if (typeof to === 'number') {
        navigate(to);
      } else {
        navigate(localePath(to), options);
      }
    },
    [navigate, localePath]
  );
};
